import { defineStore } from 'pinia'

import actions from './actions.js';
import getters from './getters.js';

// Scope filter memory to the current URL so pages don't share local storage
const urlScopedKey = (key) => {
    const current = typeof window !== 'undefined'
        ? `${window.location.pathname}${window.location.search}`
        : 'default';

    return `${current}::${key}`;
};

const readLocal = (key, fallback = null) => {
    if (typeof localStorage === 'undefined') {
        return fallback;
    }
    
    const scopedKey = urlScopedKey(key);
    const value = localStorage.getItem(scopedKey);

    if (key === 'product_page_filter_memory_misc_filters') {
        const base = { favourites: false }
        if (value === null || value === '') {
            return { ...base }
        }
        try {
            const parsed = JSON.parse(value)
            if (typeof parsed === 'object' && parsed !== null && ! Array.isArray(parsed)) {
                return { ...base, ...parsed }
            }
        } catch (e) {
            // ignore parse errors
        }
        return { ...base }
    }
    
    if (value === null) {
        return fallback;
    }
    
    // Try to parse as JSON for array values (brands, certifications)
    if (key.includes('brands') || key.includes('certifications')) {
        try {
            const parsed = JSON.parse(value);
            return Array.isArray(parsed) ? parsed : fallback;
        } catch (e) {
            // If it's a string that looks like an array, try to handle it
            if (typeof value === 'string' && value.startsWith('[') && value.endsWith(']')) {
                try {
                    const parsed = JSON.parse(value);
                    return Array.isArray(parsed) ? parsed : fallback;
                } catch (e2) {
                    return fallback;
                }
            }
            return fallback;
        }
    }
    
    return value === '' ? null : value;
};

import {
    actions as filterActions,
    getters as filterGetters,
} from '../../../mixins/store/filters.js'

export const useProductStore = defineStore('products', {
    namespaced: true,
    state: () => ({
        loading: false,
        loadingMore: false,
        pageIsReady: false,
        saving: false,
        data: [],
        meta: {},
        noResultsMessage: null,
        resultsTotal: null,
        pagination: {
            current_page: 0,
            last_page: null,
            total: null,
        },
        filterState: {
            loading: false,
            showFilterMenu: false,
            showFilter: null,
            search: readLocal('product_page_filter_memory_search', null),
            category: null,
            filters: {
                brands: [],
                certifications: [],
                types: [],
            },
            miscFilters: readLocal('product_page_filter_memory_misc_filters', { favourites: false }),
            // Memory stores a list of selected items from memory
            memory: {
                brands: readLocal('product_page_filter_memory_brands', []),
                certifications: readLocal('product_page_filter_memory_certifications', []),
            }
        }
    }),
    actions: {
        ...filterActions,
        ...actions,
    },
    getters: {
        ...getters,
        ...filterGetters
    }
})
